import { Link } from 'react-router-dom';
import type { SemanticSIZES } from 'semantic-ui-react';
import { Image } from 'semantic-ui-react';
import styled from 'styled-components';
import { routeWithQueryParams } from 'utils/helpers';
import type { FunctionalComponent } from 'apps/core/types/global.types';
import appTheme from 'theme-config';

interface Props {
  size?: SemanticSIZES;
  inverted?: boolean;
  asLink?: boolean;
}

const StyledLogo = styled.div({
  display: 'flex',
  alignItems: 'center',
});

const Logo: FunctionalComponent<Props> = ({ size, inverted = false, asLink = false }) => {
  const getLogoSrc = () =>
    inverted && appTheme.logo.invertedSrc ? appTheme.logo.invertedSrc : appTheme.logo.src;

  return (
    <StyledLogo>
      <Image
        as={asLink ? Link : null}
        to={asLink ? routeWithQueryParams('/') : null}
        size={size}
        width={160}
        src={getLogoSrc()}
      />
    </StyledLogo>
  );
};

export default Logo;
